import { memo } from "react";
import { TableItemId } from "../../../../components/tables/TableWidget";
import { receptionRoutes } from "../../../../router/routesConstants";
import ActionMenu, {
  ActionMenuItem,
} from "../../../../components/actionMenu/ActionMenu";
import { TableItemType } from "../../../../components/tables/tableContext/TableContext";

function PutawayTableActionButtons({
  crudData,
}: {
  itemId: TableItemId;
  tableItemData: TableItemType[];
  crudData?: any;
  tableContext?: any;
}) {
  const handleputawayOperations = () => {
    return `/${receptionRoutes.reception}/${receptionRoutes.transferReceived}/${receptionRoutes.splitOperations}?reception=${crudData.idFluxReceptie}`;
  };
  const items: ActionMenuItem[] = [
    {
      id: "transfer",
      label: "Transfer",
      icon: "DOCUMENTS",
      tooltip: "Deschide operatiunile de transfer ale receptiei.",
      navigate: handleputawayOperations(),
    },
  ];

  return (
    <div>
      <ActionMenu
        items={items}
        minItemsForMenu={2}
        title={crudData?.numeFurnizor}
        ariaLabel={`Actiuni pentru transferul receptiei ${crudData.idFluxReceptie}`}
      />
    </div>
  );
}

export default memo(PutawayTableActionButtons);
